import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import i18n from './i18n'

const head = createHead()

createApp(App).use(i18n).use(head).mount('#app')
